<app-chat-card
  class="coming-soon-card"
  [header]="'Organize Your Work Like a Pro! (Coming Soon)'"
  [description]="
    'Projects will help you manage and organise your conversations and knowledge files.'
  "
  [route]="'/chat'"
>
</app-chat-card>
